// Source de vérité partagée pour les icônes de spécialités.
// - `ServiceIcon.tsx` (rendu) importe SLUG_TO_ICON + DEFAULT_SERVICE_ICON.
// - `collections/Services.ts` (back office) importe SERVICE_ICON_OPTIONS + DEFAULT_SERVICE_ICON
//   pour proposer une liste déroulante d'icônes au client.
//
// ⚠️ Chaque `value` ci-dessous DOIT correspondre à une clé présente dans l'objet
// `ICONS` de `src/components/ui/ServiceIcon.tsx`, sinon l'icône par défaut est affichée.

export const DEFAULT_SERVICE_ICON = 'doctor'

// Icône déduite automatiquement du slug quand le champ `icone` n'est pas renseigné.
// Conserve l'apparence existante des spécialités créées avant l'ajout du sélecteur.
export const SLUG_TO_ICON: Record<string, string> = {
  orthodontie: 'tooth',
  'onco-esthetique': 'ribbon',
  podologie: 'orthotics',
  dietetique: 'nutrition',
  pedicure: 'foot',
  'appareils-auditifs': 'hearing-aid',
  optique: 'eyeglasses',
  logopedie: 'speech-language_therapy',
  kinesitherapie: 'pain',
  psychologie: 'mental-health',
  'protheses-dentaires': 'tooth',
  dentisterie: 'tooth',
  cardiologie: 'heart-cardiogram',
  pediatrie: 'child-care',
  'medecine-generale': 'doctor',
  ophtalmologie: 'eye',
  'o-r-l': 'ear-nose-throat',
  dermatologie: 'tissue',
  'prelevements-sanguins': 'blood-drop',
  'prise-de-sang': 'blood-drop',
}

// Liste proposée dans le back office (label lisible → clé d'icône).
// L'icône par défaut est placée en tête.
export const SERVICE_ICON_OPTIONS: { label: string; value: string }[] = [
  { label: 'Médecin / silhouette (défaut)', value: 'doctor' },
  { label: 'Stéthoscope', value: 'stethoscope' },
  { label: 'Cœur / cardiologie', value: 'heart-cardiogram' },
  { label: 'Dent / dentisterie', value: 'tooth' },
  { label: 'Enfant / pédiatrie', value: 'child-care' },
  { label: 'Œil / ophtalmologie', value: 'eye' },
  { label: 'Lunettes / optique', value: 'eyeglasses' },
  { label: 'ORL (oreille · nez · gorge)', value: 'ear-nose-throat' },
  { label: 'Appareil auditif / audiologie', value: 'hearing-aid' },
  { label: 'Logopédie / parole', value: 'speech-language_therapy' },
  { label: 'Santé mentale / psychologie', value: 'mental-health' },
  { label: 'Nutrition / diététique', value: 'nutrition' },
  { label: 'Pied / pédicure', value: 'foot' },
  { label: 'Orthopédie / semelles', value: 'orthotics' },
  { label: 'Douleur / kinésithérapie', value: 'pain' },
  { label: 'Ruban / onco-esthétique', value: 'ribbon' },
  { label: 'Peau / dermatologie', value: 'tissue' },
  { label: 'Goutte de sang / prélèvements', value: 'blood-drop' },
  { label: 'Seringue / injections', value: 'syringe' },
  { label: 'Croix médicale (générique)', value: 'medical-cross' },
]
